import { axiosGet, axiosPost, axiosPut, axiosDelete } from '../axios/httpRequest';

/**
 * 获取管理员列表
 */
export const getAdminListApi = params => {
    return axiosGet('api/admin/v1/admin', params);
};

/**
 * 添加管理员
 */
export const postAddAdminApi = params => {
    return axiosPost('api/admin/v1/admin', params);
};

/**
 * 修改管理员
 */
export const putEditAdminApi = params => {
    return axiosPut(`api/admin/v1/admin/${params.id}`, params);
};

/**
 * 获取管理员角色
 */
export const getAdminRoleApi = params => {
    return axiosGet(`api/auth/v1/admin/${params.admin_id}/role`, params);
};

/**
 * 增加管理员角色
 */
export const postAddAdminRoleApi = params => {
    return axiosPost(`api/auth/v1/admin/${params.admin_id}/role/${params.role_id}`, params);
};

/**
 * 移除管理员角色
 */
export const delAdminRoleApi = params => {
    return axiosDelete(`api/auth/v1/admin/${params.admin_id}/role/${params.role_id}`, params);
};

/**
 * 修改密码
 */
export const putPasswordApi = params => {
    return axiosPut('api/admin/v1/admin/password', params);
};
